<template>
  <div class="fade-in">
    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="is-pulled-left">
          <h1 class="title">User List – {{ practice.attributes.name }}</h1>
        </div>
        <div class="is-pulled-right">
          <div>
            <router-link
              :to="{ name: 'user-create' }"
              class="button is-primary is-small is-pulled-right"
            >
              <i class="fa fa-plus"></i> Add New User
            </router-link>

            <button
              class="mr2 button is-small is-pulled-right"
              v-if="$can('role:manage')"
              @click="existingModal"
            >
              <i class="fa fa-plus"></i> Add Existing User
            </button>
          </div>
        </div>
      </div>
    </div>

    <table class="table is-responsive">
      <thead>
        <tr>
          <th>Name</th>
          <th>Contacts</th>
          <th>Role</th>
          <th>
            Interview <br />
            Notifications
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="user in users"
          :class="[{ deleted: user.attributes.deletedAt }]"
        >
          <td>
            {{ user.attributes.firstName }} {{ user.attributes.lastName }}
            <br />
            {{ user.attributes.title }}
          </td>
          <td>
            {{ user.attributes.email }}
            <br />
            {{ user.attributes.phoneNumber }}
          </td>
          <td>{{ user.attributes.roleId }}</td>
          <td>
            <i
              :class="[
                'fa',
                'fa-envelope-o',
                'fa-small',
                { 'has-text-grey-light': !user.attributes.notifyEmail }
              ]"
              title="email"
            ></i>
            &nbsp;
            <i
              :class="[
                'fa',
                'fa-mobile',
                { 'has-text-grey-light': !user.attributes.notifyText }
              ]"
              title="sms"
            ></i>
          </td>
          <td>
            <span v-if="!user.attributes.deletedAt">
              <router-link
                :to="{
                  name: 'user-edit',
                  params: { id: practice.id, userId: user.id }
                }"
                title="Edit"
              >
                <i class="fa fa-pencil"></i>
              </router-link>
              <a
                href="#"
                v-on:click.prevent="userDelete(user)"
                class="ml1"
                title="Delete"
                ><i class="fa fa-times"></i
              ></a>
            </span>
            <span v-if="user.attributes.deletedAt">
              <a
                href="#"
                v-on:click.prevent="userReinstate(user)"
                class="ml1"
                title="Reinstate"
              >
                <i
                  :class="['fa', 'fa-refresh', { 'fa-spin': reinstateWorking }]"
                ></i>
              </a>
            </span>
          </td>
        </tr>
      </tbody>
    </table>

    <alert ref="alert" title="Confirm Delete" :onConfirm="onConfirm"
      >Are you sure you want to delete this user?</alert
    >
    <vue-toastr ref="toastr" />
    <existing-user-modal
      :show="existingModalShow"
      :hide="existingModalHide"
      :errorMessage="existingModalError"
      :practiceId="$props.id"
    />
  </div>
</template>

<script>
import PracticesService from "@/services/PracticesService";
import alert from "@/components/alert";
import ExistingUserModal from "./ExistingUserModal";

export default {
  name: "practice-user-list",

  props: ["id"],

  data() {
    return {
      loading: true,
      userId: null,
      w: this.id,
      reinstateWorking: false,
      existingModalShow: false
    };
  },

  components: {
    ExistingUserModal,
    alert
  },

  computed: {
    users() {
      return this.$store.getters["practice/users"];
    },
    practice() {
      return this.$store.getters["practice/get"](this.$props.id);
    }
  },

  methods: {
    userDelete(user) {
      this.$refs.alert.open();
      this.userId = user.id;
    },
    onConfirm() {
      PracticesService.deleteUser(this.userId)
        .then(() => {
          this.$store.dispatch("practice/removeUser", this.userId);
          this.$refs.toastr.s("The practice has been deleted.");
          this.practiceId = null;
        })
        .catch(() => {
          this.$refs.toastr.e("There was an error deleting the practice.");
          this.practiceId = null;
        });
    },
    userReinstate(user) {
      this.reinstateWorking = true;
      PracticesService.reinstateUser(user.id)
        .then(() => {
          this.reinstateWorking = false;
          this.$store.dispatch("practice/reinstateUser", this.userId);
        })
        .catch(e => {
          this.reinstateWorking = false;
          console.log("error", e);
        });
    },
    load() {
      PracticesService.getUsers(this.$props.id).then(() => {
        this.loading = false;
      });
    },
    existingModal() {
      this.existingModalShow = true;
    },
    existingModalHide() {
      this.existingModalShow = false;
      this.load();
    },
    existingModalError(message) {
      this.$refs.toastr.e(message);
    }
  },

  mounted() {
    this.load();
  }
};
</script>

<style lang="scss">
.deleted > td,
.deleted > td > a,
.deleted > td > i {
  /*background: #ff7675;*/
  text-decoration: line-through;
  color: #d63031;
}

.fa-small {
  font-size: 17px;
}
</style>
